// extracted by mini-css-extract-plugin
module.exports = {"appModalH5":"AppModal_appModalH5__qIrC8"};